import React, { useEffect, useState } from 'react';
import { Typography, Space, Button, DatePicker, Form, notification, Divider } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { ClockCircleOutlined, EditOutlined, SaveOutlined, StopOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { apis, models } from '@vote4dance/judging-sdk';
var Api = apis.Api;
var CompetitionSource = models.competitions.CompetitionsSource;
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
const { Text } = Typography;
const { RangePicker } = DatePicker;
const dateTimeFormat = 'YYYY-MM-DD HH:mm';
export const CheckinTimeEdit = (props) => {
    const { item, disabled } = props;
    const [form] = Form.useForm();
    const [active, setActive] = useState((item === null || item === void 0 ? void 0 : item.competition_open_checkin) != null);
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const getTime = (item, attr) => (dayjs.utc(item[attr]).tz(item.competition_timezone));
    useEffect(() => {
        const nextActive = (item === null || item === void 0 ? void 0 : item.competition_open_checkin) != null;
        setActive(nextActive);
        setEditing(false);
        if (nextActive && (item === null || item === void 0 ? void 0 : item.competition_open_checkin) != null && (item === null || item === void 0 ? void 0 : item.competition_close_checkin) != null) {
            form.setFieldValue('range', [
                getTime(item, 'competition_open_checkin'),
                getTime(item, 'competition_close_checkin')
            ]);
            return;
        }
        form.resetFields();
    }, [
        form,
        item === null || item === void 0 ? void 0 : item.competition_id,
        item === null || item === void 0 ? void 0 : item.competition_open_checkin,
        item === null || item === void 0 ? void 0 : item.competition_close_checkin,
        item === null || item === void 0 ? void 0 : item.competition_timezone
    ]);
    const onFinish = (values) => {
        const ranges = values['range'];
        const from = (dayjs(ranges[0]));
        const to = (dayjs(ranges[1]));
        if (item) {
            const updateItem = {
                ...item,
                competition_open_checkin: from.utc().format(dateTimeFormat),
                competition_close_checkin: to.utc().format(dateTimeFormat)
            };
            saveChanges(updateItem);
        }
    };
    const saveChanges = async (updateItem) => {
        setLoading(true);
        await Api.update(`${CompetitionSource.url}/${item === null || item === void 0 ? void 0 : item.competition_id}`, updateItem)
            .catch((err) => {
            notification.error({
                message: err.name
            });
        });
        setLoading(false);
    };
    const onCancel = () => {
        form.resetFields();
        setEditing(false);
    };
    const onActivate = (done) => {
        setActive(true);
        setEditing(true);
        done();
    };
    const onDisable = (done) => {
        const updateItem = {
            ...item,
            competition_open_checkin: null,
            competition_close_checkin: null
        };
        saveChanges(updateItem);
        form.resetFields();
        setActive(false);
        done();
    };
    if (!active) {
        return (React.createElement(ButtonConfirm, { title: _T('common.activate.title', { name: _T('checkin.title').toLowerCase() }), description: _T('common.activate.content', { name: _T('checkin.title').toLowerCase() }), onConfirm: onActivate, buttonProps: {
                type: 'primary',
                icon: React.createElement(ClockCircleOutlined, null),
                disabled: disabled
            } }));
    }
    return (React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
        React.createElement(Form, { form: form, name: "checkin_time_edit", layout: "inline", disabled: loading || disabled, onFinish: onFinish },
            React.createElement(Form.Item, { name: "range", rules: [{ type: 'array', required: true }] },
                React.createElement(RangePicker, { disabled: !editing, showTime: true, format: dateTimeFormat })),
            React.createElement(Form.Item, null,
                !editing &&
                    React.createElement(Button, { onClick: (() => setEditing(!editing)), icon: React.createElement(EditOutlined, null) }, _T('common.edit')),
                editing &&
                    React.createElement(Space, null,
                        React.createElement(Button, { onClick: onCancel }, _T('common.cancel.title')),
                        React.createElement(Button, { type: "primary", disabled: disabled, htmlType: "submit", icon: React.createElement(SaveOutlined, null) }, _T('common.save'))))),
        React.createElement(Divider, null),
        React.createElement(Text, { type: item && item.competition_is_checkin_open > 0 ? "success" : "danger" },
            React.createElement(ClockCircleOutlined, null),
            " ",
            _T('checkin.status.' + (item && item.competition_is_checkin_open > 0 ? 'open' : 'closed'))),
        React.createElement(ButtonConfirm, { title: _T('common.disable.title', { name: _T('checkin.title').toLowerCase() }), description: _T('common.disable.content', { name: _T('checkin.title').toLowerCase() }), onConfirm: onDisable, buttonProps: {
                danger: true,
                icon: React.createElement(StopOutlined, null),
                disabled: disabled
            } })));
};
